import { render, staticRenderFns } from "./OldNewRateInput.vue?vue&type=template&id=031579b7"
import script from "./OldNewRateInput.vue?vue&type=script&lang=js"
export * from "./OldNewRateInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports